import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import { ThemeContext } from "../context/IsLoader";
import load_img from "../assets/images/report_load.gif";
import customFetch from "./apicall/api";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import { DatePicker, Select } from "antd";
import SupersetDashboardEmbed from "./SupersetDashboardEmbed";
import ReportHeader from "./Report_header";
import { useHistory, useLocation } from "react-router-dom";
import DynamicForm from "./Report_dynamic_form"

function SupersetDashboard(props) {
  const theme = useContext(ThemeContext);
  const history = useHistory();
  const location = useLocation();

  const [reportListData, setReportListData] = useState([]);
  const [isVisible, setIsVisible] = useState(true);
  const [isInitial, setIsInitial] = useState(true);
  const [isSpin, setIsSpin] = useState(false);
  const [pin, setPin] = useState(false);
  const [drop, setDrop] = useState(false);
  const [supersetId, setSupersetId] = useState("");
  const [supersetUrl, setSupersetUrl] = useState("");
  const [reportId, setReportId] = useState("");
  const [reportName, setReportName] = useState("");
  const [supersetInputData, setSupersetInputData] = useState([]);
  const [affinityDict, setAffinityDict] = useState({});

  // Create affinity dict from affinity_list
  useEffect(() => {
    if (affinity_list && Array.isArray(affinity_list) && affinity_list.length > 0) {
      const dict = {};
      affinity_list.forEach((item, index) => {
        dict[`in_s${index + 1}`] = item;
      });
      setAffinityDict(dict);
    } else {
      setAffinityDict({});
    }
  }, [affinity_list]);

  // Inject responsive body padding style only for this component
  const reportBodyStyle = document.createElement('style');
  reportBodyStyle.setAttribute('data-report-body-padding', 'true');
  reportBodyStyle.innerHTML = `@media (max-width: 768px) { body { padding: 0 !important; } }`;
  document.head.appendChild(reportBodyStyle);

  if (window.Android) {
      document.head.appendChild(reportBodyStyle);
  }

  useEffect(() => {
    const { api_token, subcategories_id, report_category_id } = location.state || {};
    setIsSpin(true);

    const formdata = new FormData();
    formdata.append("report_subcategory_id", subcategories_id);
    formdata.append("report_category_id", report_category_id)
    formdata.append("employee_id", localStorage.getItem("employee_id"));

    customFetch(process.env.REACT_APP_URL + "/get/report/list", {
      method: "POST",
      headers: { "api-token": api_token },
      body: formdata,
    })
      .then((res) => res.json())
      .then((data) => {
        if ([3, 4, 5].includes(data.api_code)) {
          localStorage.clear();
          this.props.history.push("/");
        } else {
          setReportListData(data);
        }
        setIsSpin(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props.api_token, props.categories_id]);

  const updateSlide = () => {
    setIsVisible(!isVisible);
    if (!isVisible) {
      setIsVisible(false);
    }
    setDrop(false);
  };

  const toggleDrop = () => {
    setDrop(!drop);
  };

  const routeState = props.location && props.location.state;
  const api_token = routeState && routeState.api_token;
  const subcategories_name = routeState && routeState.subcategories_name;
  const hideHeader = routeState && routeState.hideHeader;
  const affinity_list = routeState && routeState.affinity_list;

  return (
    <>
      {isSpin && (
        <div className="preloader">
          <div className="loader" />
        </div>
      )}
      {pin && (
        <div className="preloader">
          <img src={load_img} />
        </div>
      )}
      <div className="container no-container" style={{ maxWidth: '-webkit-fill-available' }}>
        {hideHeader && <ReportHeader
          title={subcategories_name}
          showBack={true}
          onBack={() => history.goBack()}
          showLogout={true}
        />}
        <div className="mb-2 inputholder mt-2">
          <div id="accordion">
            <div>
              <div
                id="headingOne"
                className={
                  !isVisible ? "report_head show_title " : "report_head "
                }
                onClick={toggleDrop}
              >
                <h5
                  className="mb-0"
                  data-toggle="collapse"
                  data-target="#collapseOne"
                  id="colapse"
                >
                  {!isInitial && !isVisible && reportName}
                </h5>
                {!isInitial &&
                  !isVisible &&
                  (drop ? <UpOutlined /> : <DownOutlined />)}
              </div>

              <div
                id="collapseOne"
                className={!isVisible && !drop ? "collapse" : "collapse show"}
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div>
                  {reportListData && reportListData.length > 0 ? (
                    <SupersetForm
                      apiToken={api_token} reportListData={reportListData}
                      updateSlide={updateSlide}
                      setSupersetId={setSupersetId}
                      setSupersetUrl={setSupersetUrl}
                      reportName={reportName}
                      setReportName={setReportName}
                      setDrop={setDrop}
                      setIsInitial={setIsInitial}
                      setSupersetInputData={setSupersetInputData}
                      setReportId={setReportId}
                      onReportChange={() => {
                        // Clear previous report data when report selection changes
                        setSupersetId("");
                        setSupersetUrl("");
                        setSupersetInputData([]);
                      }}
                    />
                  ) : (
                    <div className="text-center">No Data Found</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {(supersetId !== "" || supersetUrl !== "") && (
          <SupersetDashboardEmbed
            supersetId={supersetId}
            supersetUrl={supersetUrl}
            supersetInputData={supersetInputData}
            affinityDict={affinityDict}
            report_id={reportId}
            setLoading={setPin}
          />
        )}
      </div>
    </>
  );
}

const SupersetForm = ({
  apiToken, reportListData,
  updateSlide,
  reportName, setReportName,
  setSupersetId, setSupersetUrl, setIsInitial, setSupersetInputData, setReportId, onReportChange
}) => {
  const [reportConfig, setReportConfig] = useState(null);
  const [extraReportConfigFields, setExtraReportConfigFields] = useState(null);
  const [selectedReportId, setSelectedReportId] = useState(null);
  const [formState, setFormState] = useState({});
  const [isFetchingConfig, setIsFetchingConfig] = useState(false);
  const [isErrorWindowActive, setErrorWindowActive] = useState(false);
  const [errorWindowMessage, setErrorWindowMessage] = useState("");

  const [loading, setLoading] = useState(false)
  const [isLoadingReport, setIsLoadingReport] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault();
    
    setIsLoadingReport(true); // Show loader when starting to load report

    const fieldsToSubmit = [];
    let validFields = true;
      
      for (const key in formState) {
        if (formState.hasOwnProperty(key)) {
          const fieldState = formState[key];

          let is_req = true;
          if (reportConfig[key] && reportConfig[key].is_req !== null && reportConfig[key].is_req !== undefined) {
            is_req = reportConfig[key].is_req
            is_req = (is_req === "1" || is_req === true || is_req === "true" || is_req === 1);
          }

          // Check if value is present and not empty
          if (fieldState.isVisible && !fieldState.isFetching && fieldState.value && is_req) {
            // Handle special cases for calendar_daterange and calendar_yearmonthrange
            if (Array.isArray(fieldState.value)) {
              fieldState.value.forEach((item) => fieldsToSubmit.push({ id: item, value: item }))
            } else {
              const fieldData = {
                id: fieldState.id,
                value: fieldState.value,
              };

              fieldsToSubmit.push(fieldData);
            }
          }
          else if (fieldState.isVisible && (fieldState.isFetching || !fieldState.value)) {
            validFields = false;
            break;
          }
        }
      }

      if (!validFields || (fieldsToSubmit.length === 0 && reportConfig && Object.keys(reportConfig).length > 0)) {
        setErrorWindowMessage(`Error sending request: Please try again.`);
        setErrorWindowActive(true);
        setIsLoadingReport(false); // Hide loader on error
        return;
      }

      const dynamicParams = fieldsToSubmit.reduce((acc, curr, index) => {
        acc[`in_p${index + 1}`] = curr.value;
        return acc;
      }, {});

    if (extraReportConfigFields.superset_id) {
      setSupersetId(extraReportConfigFields.superset_id)
      setSupersetUrl("")
    }
    else if (extraReportConfigFields.superset_url) {
      setSupersetId("")
      setSupersetUrl(extraReportConfigFields.superset_url)
    }
    setSupersetInputData(dynamicParams)
    setReportId(selectedReportId)
    setIsLoadingReport(false); // Hide loader after loading
  };

  // Helper to check if all visible fields are completed with textbox `status` check
  const areVisibleFieldsComplete = () => {
    if (!formState || !reportConfig) return false;
    
    return Object.keys(formState).every((key) => {
      const field = formState[key];
      const config = reportConfig[key];
      if (!field || !field.isVisible) return true; // Skip non-visible fields
      if (config && config.type === "textbox") return field.value && config.status === 1; // Check textbox status
      return field.value !== "" && field.value !== null; // Check other field types
    });
  };

  // Helper to determine if any field is fetching data
  const isAnyFieldFetching = () => {
    if (!formState) return false;
    return Object.keys(formState).some((key) => formState[key] && formState[key].isFetching);
  };

  const checkFetchingState = () => {
    return isFetchingConfig || isAnyFieldFetching();
  };

  return (
    <>
      <style>
        {`
          .btn {
            background-color: #138496 !important;
            border-color: #138496 !important;
            color: #fff !important;
          }
          .btn-info:hover {
            background-color: #138496 !important;
            border-color: #138496 !important;
          }
          .btn-info:focus {
            box-shadow: none !important;
            outline: none !important;
          }
        `}
      </style>
      {isLoadingReport && (
        <div className="preloader">
          <div className="loader" ng-hide="data.length > 0"></div>
        </div>
      )}
      <div
        className={`modal fade ${isErrorWindowActive ? "show mymodal" : ""}`}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="errorModalLabel"
        aria-hidden={!isErrorWindowActive}
        style={{ display: isErrorWindowActive ? "block" : "none" }}
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content cdb-confirm-box col-sm-12">
            <button
              type="button"
              className="close text-right"
              aria-label="Close"
              onClick={() => {
                setErrorWindowActive(false);
                setErrorWindowMessage(""); // Clear error message on close
              }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <p>{errorWindowMessage}</p>
          </div>
        </div>
      </div>
      <div className="mt-12">
        <div className="row">
          <DynamicForm
            apiToken={apiToken} reportListData={reportListData}
            reportConfig={reportConfig} setReportConfig={setReportConfig}
            extraReportConfigFields={extraReportConfigFields} setExtraReportConfigFields={setExtraReportConfigFields}
            currentReportId={selectedReportId} setCurrentReportId={setSelectedReportId}
            currentReportName={reportName} setCurrentReportName={setReportName}
            formState={formState} setFormState={setFormState}
            isFetchingConfig={isFetchingConfig} setIsFetchingConfig={setIsFetchingConfig}
            isErrorWindowActive={isErrorWindowActive} setErrorWindowActive={setErrorWindowActive}
            errorWindowMessage={errorWindowMessage} setErrorWindowMessage={setErrorWindowMessage}
            setSupersetId={setSupersetId} setSupersetUrl={setSupersetUrl}
          />

          {selectedReportId && (areVisibleFieldsComplete() && !checkFetchingState()) && (
            <div className="col-md-2">
              <span className="f18">&nbsp;</span>
              <button
                disabled={isLoadingReport}
                className={
                  // "form-control btn-primary p-2 btn-height"
                  "btn btn-info form-control"
                }
                onClick={(e) => {
                  setIsInitial(false);
                  setLoading(false);
                  handleSubmit(e)
                  updateSlide()
                }}
              >
                {isLoadingReport ? "Loading..." : "Load"}
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SupersetDashboard;
